import _ from "lodash";
import React from "react";
import Select, { OptionTypeBase, ValueType } from "react-select";

import { TypeSelectorOptions } from "../types";
const typesMap = _.keyBy(TypeSelectorOptions, "value");

type ConstType = ValueType<OptionTypeBase>;
type SetConstStrFn = (constStr: string) => void;
type SetConstTypeFn = (constType: ConstType) => void;

export const SendConstantPropertyInputs: React.FC<{
  constStr: string;
  setConstStr: SetConstStrFn;
  constType: ConstType;
  setConstType: SetConstTypeFn;
  operandValue: string;
  setOperandValue: (operandValue: string) => void;
}> = ({
  constStr,
  setConstStr,
  constType,
  setConstType,
  operandValue,
  setOperandValue,
}) => {
  return (
    <>
      <input
        className="py-2 px-2 w-full mt-2 font-mono border rounded tracking-tight"
        placeholder="Property Name"
        value={operandValue}
        onChange={(e) => setOperandValue(e.target.value)}
      />
      <input
        className="py-2 px-2 w-full mt-2 font-mono border rounded tracking-tight"
        placeholder="Property Value"
        value={constStr}
        onChange={(e) => setConstStr(e.target.value)}
      />
      <Select
        className="mt-2"
        placeholder="Constant Type"
        value={constType}
        options={TypeSelectorOptions}
        onChange={setConstType}
      />
    </>
  );
};

export function initSendConstPropInputState(
  targetValue: string,
  setConstStr: SetConstStrFn,
  setConstType: SetConstTypeFn
) {
  let parsedTargetValue = "";
  try {
    parsedTargetValue = JSON.parse(targetValue);
  } catch (error) {
    console.error(
      "Failed to parse json from targetValue - ",
      targetValue,
      " errror - ",
      error
    );
  }

  let targetType = typeof parsedTargetValue;
  if (
    targetType !== "number" &&
    targetType !== "boolean" &&
    targetType !== "string"
  ) {
    targetType = "string";
  }

  setConstStr(String(parsedTargetValue));
  setConstType(typesMap[targetType]);
}

export function getSendConstPropTargetValue(
  constStr: string,
  constType: ConstType
) {
  // @ts-ignore
  const typeKey: string = (constType && constType.value) || "string";

  let obj;
  if (typeKey === "number") {
    obj = Number(constStr);
    if (Number.isNaN(obj)) {
      obj = 0;
    }
  } else if (typeKey === "boolean") {
    obj = stringToBoolean(constStr);
  } else {
    obj = constStr;
  }

  return JSON.stringify(obj);
}

function stringToBoolean(s: string): boolean {
  s = s.toLowerCase();
  if (s === "t" || s === "true") {
    return true;
  }
  return false;
}
